import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./apparecchioCategoriesStore"
import Actions from "./ImpiantiTermiciActions"

export let withApparecchioCateogories = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getApparecchioCategories());